import { useState } from "react";
import { useTranslations } from "../../hooks/useTranslations";
import ModalDialog from "../ui/ModalDialog";
import Page from "../ui/Page";
import styles from "./Agreements.module.css";
import AgreementsTable from "./AgreementsTable";
import DocumentsTable from "./DocumentsTable";

const Agreements = () => {
  const { i18n } = useTranslations();
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <Page
      title={i18n.agreements.title}
      description={
        <>
          {i18n.agreements.description}
          <br />
          <br />
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setModalOpen(true);
            }}
          >
            {i18n.agreements.hint}
          </a>
        </>
      }
    >
      <div className={styles.tables}>
        <DocumentsTable />
        <AgreementsTable />
      </div>
      <ModalDialog
        title={i18n.agreements.hint}
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      >
        <p>
          {i18n.agreements.hintText.paragraph1}
          <br />
          <br />
          {i18n.agreements.hintText.paragraph2}
          <br />
          <br />
          {i18n.agreements.hintText.paragraph3}
          <br />
          <br />
          {i18n.agreements.hintText.paragraph4}
        </p>
      </ModalDialog>
    </Page>
  );
};

export default Agreements;
